var map = {
	"./dropdown.png": 78183,
	"./example.png": 3164,
	"./form.png": 40074,
	"./header.png": 43871,
	"./input.png": 60494,
	"./linkedin.png": 82098,
	"./p1.png": 98209,
	"./p10.png": 45045,
	"./p11.png": 9132,
	"./p2.png": 49226,
	"./p3.png": 88083,
	"./p4.png": 4476,
	"./p5.png": 33893,
	"./p6.png": 45742,
	"./p7.png": 5111,
	"./p8.png": 38224,
	"./p9.png": 35129,
	"./prompt.png": 83822,
	"./settings.png": 87959,
	"./text.png": 32629,
	"./transcription.png": 46834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50715;